/* jshint esversion: 6 */

import linkifyHtml from 'linkifyjs/html';
import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

class WebsiteWidgetMessage extends React.Component {
  render() {
    return (
      <div  id={this.props.id}
            className={'message-box ' + this.props.direction}
            data-status={this.props.status}
            data-direction={this.props.direction}>
        <div className={this.props.direction + "bound-message"}>
          <div
            className="message-text"
            dangerouslySetInnerHTML={{
              __html: linkifyHtml(this.props.messageText, {defaultProtocol: 'https'}),
            }} />
        </div>
        <div className={'chat-timestamp stamp-' + this.props.direction}>
          - <time dateTime={new Date(this.props.sentAt).toISOString()} data-local="time" data-format="%m/%d/%Y at %l:%M %P" />
        </div>
      </div>
    );
  }
}

WebsiteWidgetMessage.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  direction: PropTypes.string,
  messageText: PropTypes.string,
  status: PropTypes.string,
  sentAt: PropTypes.number,
};

export default WebsiteWidgetMessage;
